/* Utils */
import { useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import {
	Switch,
	Route,
	useLocation,
	useHistory
} from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

/* Stores */
import useModalStore from 'Stores/Modals';
import useSnackBarStore from 'Stores/SnackBar';
import useUserStore from 'Stores/User';

/* Pages */
import Login from 'Pages/Login';
import Home from 'Pages/Home';
import Inventory from 'Pages/Inventory';
import Orders from 'Pages/Orders';

/* Components */
import Sidebar from 'Components/Sidebar';
import ModalWrapper from 'Components/ModalWrapper';
import SnackBar from 'Components/SnackBar';

/* Styles */
import 'Styles/main.scss';

const App = () => {
	const showModal = useModalStore(state => state.showModal);
	const isSnackBarActive = useSnackBarStore(state => state.isSnackBarActive);
	const activeModal = useModalStore(state => state.activeModal);
	const currentUser = useUserStore(state => state.currentUser);
	const setUser = useUserStore(state => state.setUser);
	const fetchUser = useUserStore(state => state.fetchUser);
	const { pathname } = useLocation();
	const history = useHistory();
	const isMobile = useMediaQuery({ query: `(max-width: ${Constants.RESPONSIVE_SM}px)` });

	const hasToken = localStorage.getItem('token');

	useEffect(() => {
		if (!currentUser && hasToken && !pathname.includes('logout')) {
			fetchUser();
		}
	}, [currentUser, pathname]);

	useEffect(() => {
		if (pathname.includes('logout')) {
			localStorage.removeItem('token');
			setUser(null);
			history.push('/');
		}
	}, [pathname]);

	return (
		<div className="App">
			{ !currentUser && !hasToken && <Login /> }
			{ currentUser && (
				<>
					<Sidebar />

					<div className={`App-main-content ${isMobile ? 'mobile' : ''}`}>
						<Switch>
							<Route path="/inventory">
								<Inventory />
							</Route>
							<Route path="/orders">
								<Orders />
							</Route>
							<Route path="/etsy/callback">
								<Home />
							</Route>
							<Route path="/" exact>
								<Home />
							</Route>
						</Switch>
					</div>
				</>
			)}

			<CSSTransition in={showModal} timeout={{ enter: 0, exit: 500 }} unmountOnExit>
				<ModalWrapper modal={activeModal} />
			</CSSTransition>
			<CSSTransition in={isSnackBarActive} timeout={{ enter: 0, exit: 500 }} unmountOnExit>
				<SnackBar />
			</CSSTransition>
		</div>
	);
};

export default App;
